module.exports = "https://static.wmbcdn.com/uniweb/images/07b97ea8fc1e79fa2a4837e9ff83bfce.svg";